<template>
	<el-drawer :modal="false"  title="Filter" :visible.sync="show_drawer" class="drawer-filter" size="20%">
		<b-container>
			<b-row class="text-end">
				<b-col cols="12">
					<div class="d-flex justify-content-end">
						<b-button variant="primary" @click="resetFilter">Reset</b-button>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<b-form-group label="Filter By Transaction Type">
						<el-select v-model="filter.cbh_transaction_type" placeholder="Filter By Transaction Type" @change="searchByFilter()">
							<el-option v-for="item in transactionTypeOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<base-input label="Filter By Transaction Period">
						<div class="">
							<div class="mb-2 w-100 ">
								From
							</div>
							<div class="mb-2">
								<el-date-picker v-model="filter.cbh_date_period.start_date" type="date" placeholder="Date From"
									value-format="yyyy-MM-dd" @change="searchByFilter()" />
							</div>
							<div class="mb-2 w-100 ">
								To
							</div>
							<div class="">
								<el-date-picker v-model="filter.cbh_date_period.end_date" type="date" placeholder="Date Until"
									value-format="yyyy-MM-dd" @change="searchByFilter()" />
							</div>
						</div>
					</base-input>
				</b-col>
			</b-row>
		</b-container>

	</el-drawer>
</template>
<script>
import { Drawer, Select, Option, DatePicker } from 'element-ui'
import {
	helperFunctionMixin,
	axios,
	services,
	getHeader,
	debounce
} from '@/assets/js/httpImports.js'
export default {
	mixins: [
		helperFunctionMixin
	],
	components: {
		[Drawer.name]: Drawer,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
	},
	computed: {
	},
	async created() {
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
			this.searchByFilter();
		}, 1000);
	},
	data() {
		return {
			tables: [],
			filter: {
				cbh_transaction_type: '',
				cbh_date_period: {
					start_date: '',
					end_date: ''
				}
			},
			show_drawer: false,
			transactionTypeOptions: [
				{
					label: 'Credit - Top Up',
					value: 'TOPUP',
				},
				{
					label: 'Credit - Bring forward',
					value: 'BRING_FORWARD',
				},
				{
					label: 'Credit - Received from transfer',
					value: 'RECEIVED',
				},
				{
					label: 'Debit - Transfer',
					value: 'TRANSFER',
				},
				{
					label: 'Debit - Used for Prescreening Analysis',
					value: 'USED',
				},
			]
		}
	},
	methods: {
		showDrawer() {
			this.show_drawer = !this.show_drawer;
		},
		searchByFilter() {
			this.$emit('filter_submit', this.filter)
		},
		resetFilter() {
			Object.keys(this.filter).forEach(key => {
				if (key == 'cbh_date_period') {
					this.filter[key] = {
						start_date: '',
						end_date: ''
					}
				} else {
					this.filter[key] = ''
				}
			});
			this.searchByFilter()
		}
	}
}
</script>